import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { RxFormBuilder, RxReactiveFormsModule, RxwebValidators } from '@rxweb/reactive-form-validators';
import { RiveModule } from 'ng-rive';
import { Subject, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/auth.service';
import { OAuthService } from '../../services/oauth.service';
import { SharedService } from '../../services/shared.service';
import { SnackbarService } from '../../services/snackbar.service';
import { UserActions } from '../../store/user/user.actions';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone: true,
  imports: [ReactiveFormsModule, MatTooltipModule, MatInputModule, RxReactiveFormsModule, RouterModule, MatButtonModule, MatIconModule, MatFormFieldModule, RiveModule, MatDividerModule, CommonModule],
})
export class LoginComponent {
  loginForm: FormGroup;
  email: any;
  isUser: boolean = false;
  redirectUrl: string | undefined;
  redirectTarget: string | null = null;
  saveForm: boolean = false;
  showPassword: boolean = false;
  googleLogin: boolean = false;
  destroy$: Subject<void> = new Subject<void>();
  googleError: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private snackBarService: SnackbarService,
    private authService: AuthService,
    private oauthService: OAuthService,
    private fb: RxFormBuilder,
    private store: Store,
    private actions$: Actions
  ) {
    this.loginForm = this.fb.group({
      email: ['', [RxwebValidators.notEmpty({ message: 'Email is required' }), RxwebValidators.email({ message: 'Invalid email' })]],
      password: ['', [RxwebValidators.notEmpty({ message: 'Password is required' }), RxwebValidators.maxLength({ value: 256, message: "Invalid password" })]],
    });
    this.route.queryParams.subscribe((params) => {
      const { encoded, decoded } = SharedService.decodeAndValidateRedirectUrl(params['redirect']);
      this.redirectUrl = encoded;
      this.redirectTarget = decoded;

      this.email = params['email'] ? atob(params['email']) : undefined
      if (this.email) {
        this.loginForm.controls['email'].patchValue(this.email)
      }
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const code = params['code'];
      const state = params['state'];
      if (code) {
        this.saveForm = true;
        this.oauthService.handleAuthCallback(code).subscribe({
          next: (response) => {
            this.authService.setAccessToken(response.data.access_token);
            this.authService.setRefreshToken(response.data.refresh_token);
            const { decoded: stateTarget } = SharedService.decodeAndValidateRedirectUrl(state);
            window.location.href = stateTarget ?? environment.sandbox_console_host;
            this.saveForm = false;
          },
          error: (error) => {
            this.saveForm = false;
            this.snackBarService.openSnackBar("Failed to Login with Google", undefined);
          }
        });
      }
    }
    )
  }


  isValid() {
    return this.loginForm.valid && this.loginForm.controls['email'].value
  }

  showError() {
    this.loginForm.markAllAsTouched();
  }
  verify() {

    this.saveForm = true;

    this.store.dispatch(UserActions.LOGIN({
      email: this.loginForm.controls['email'].value,
      password: this.loginForm.controls['password'].value
    }))

    this.actions$.pipe(ofType(UserActions.LOGIN_SUCCESS), take(1)).subscribe((data) => {
      this.authService.setAccessToken(data.accessToken);
      this.authService.setRefreshToken(data.refreshToken);
      window.location.href = this.redirectTarget ?? environment.sandbox_console_host;
      this.saveForm = false;

    })
    this.actions$.pipe(ofType(UserActions.LOGIN_FAILED), take(1)).subscribe(({ err }) => {
      if (err.error.message) {

        if (err.error.code == 400 && err.error.message.includes('Password not set for user')) {
          this.router.navigate(['/forgot-password/sent'], { state: { email: this.loginForm.controls['email'].value } })
          return;
        }

        else if (err.error.message.includes('Invalid email or password')) {
          this.snackBarService.openSnackBar('Invalid email or password', undefined);

        }
        else {
          this.snackBarService.openSnackBar('Failed to login', undefined);
        }
      }

      this.saveForm = false;

    })
  }

  navigateToForgotPassword() {
    this.router.navigate(['../forgot-password'], { relativeTo: this.route })
  }

  loginWithGoogle() {
    this.oauthService.authorizeGoogle(this.redirectUrl);
  }

  getYear() {
    return new Date().getFullYear();
  }

  navigateToSignup() {
    this.router.navigate(['../signup'], { relativeTo: this.route, state: { email: this.email } })
  }

}

